import { render, staticRenderFns } from "./SlideTextToolbar.vue?vue&type=template&id=03c6ab94&scoped=true"
import script from "./SlideTextToolbar.vue?vue&type=script&lang=ts"
export * from "./SlideTextToolbar.vue?vue&type=script&lang=ts"
import style0 from "./SlideTextToolbar.vue?vue&type=style&index=0&id=03c6ab94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c6ab94",
  null
  
)

export default component.exports